/**
 * Telegram Groups Configuration
 *
 * UPDATED: Using single unified group for all languages
 * URL: https://t.me/+YMpuDwLakd8xODYx
 *
 * This group serves:
 * - España + LATAM (Spanish speakers)
 * - US, Germany, France, and rest of world (English speakers)
 *
 * Environment Variable (Railway):
 * - VITE_TELEGRAM_GROUP_URL - Main Telegram group (all languages)
 */

// Unified Telegram Group for all users
const DEFAULT_TELEGRAM_GROUP_URL = "https://t.me/+YMpuDwLakd8xODYx";

// Main Telegram Group (for all languages)
export const TELEGRAM_GROUP_URL =
  (import.meta.env.VITE_TELEGRAM_GROUP_URL as string) ||
  DEFAULT_TELEGRAM_GROUP_URL;

// Backward compatibility - both point to same group
export const TELEGRAM_GROUP_SPANISH = TELEGRAM_GROUP_URL;
export const TELEGRAM_GROUP_ENGLISH = TELEGRAM_GROUP_URL;

/**
 * Get Telegram group URL based on language/region
 * @param isSpanishSpeaker - Whether the user speaks Spanish (España or LATAM)
 * @returns Telegram group URL (same for all languages now)
 */
export function getTelegramGroupByLanguage(isSpanishSpeaker: boolean): string {
  // Returns same URL for all languages
  return TELEGRAM_GROUP_URL;
}

/**
 * Get Telegram group URL based on region
 * @param region - User's region ("SPAIN", "LATAM", "US", "OTHER")
 * @returns Telegram group URL (same for all regions now)
 */
export function getTelegramGroupByRegion(region: string): string {
  // Returns same URL for all regions
  return TELEGRAM_GROUP_URL;
}

export default {
  TELEGRAM_GROUP_URL,
  TELEGRAM_GROUP_SPANISH,
  TELEGRAM_GROUP_ENGLISH,
  getTelegramGroupByLanguage,
  getTelegramGroupByRegion,
};
